import React from 'react';
import { ROUTES } from '../../../../../common/constants';
import GoBackButton from '../../../../../components/GoBackButton';
import Portal from '../../../../../components/Portal';
import InflowTable from '../../../../payments/modules/endUser/components/InflowTable';
import EndUsersTabs from '../components/EndUsersTabs';

const ViewTransactionDetails = ({
  match: { params: { id, userNumber } = {} } = {},
}) => (
  <>
    <Portal portalId="header-title-content">
      <GoBackButton
        customLink={`${ROUTES?.SYSTEM_USERS}${ROUTES?.END_USERS}`}
      />
      <div className="portal-header">View End User</div>
    </Portal>
    <EndUsersTabs endUserId={id} endUserNumber={userNumber} isView>
      <div className="tab-table">
        <InflowTable userId={id} />
      </div>
    </EndUsersTabs>
  </>
);

export default ViewTransactionDetails;
